import { render, staticRenderFns } from "./DashboardSidebar.vue?vue&type=template&id=7bb8d229&scoped=true"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js"
import style0 from "./DashboardSidebar.vue?vue&type=style&index=0&id=7bb8d229&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8d229",
  null
  
)

export default component.exports